
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

/* eslint-disable */
import { Nav, NavLink as ReactstrapNavLink } from "reactstrap";
import {
  BackgroundColorContext,
} from "../../contexts/BackgroundColorContext";

var ps;

function Sidebar(props) {
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  const { routes } = props;
  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="sidebar" data={color}>
          <div className="sidebar-wrapper" ref={sidebarRef}>
            <Nav>
              {routes.map((prop, key) => {
                if (prop.redirect) return null;
                if (prop.Navpath && props.Navpath !== "") {
                  return (
                    <li
                      className={
                        activeRoute(prop.Navpath)
                      }
                      key={key}
                    >
                      <NavLink
                        to={prop.Navpath}
                        className="nav-link"
                        activeClassName="active"
                        onClick={props.toggleSidebar}
                        style={{ borderBottomStyle: "inset", borderRadius: "0px" }}
                      >
                        <i className={prop.icon} />
                        <p style={{ fontSize: "12px", fontWeight: "bold" }}>{prop.rtlName}</p>
                      </NavLink>
                    </li>
                  );
                }
              })}
            </Nav>
            <div style={{ textAlign: "center", marginTop: "25px" }}>
              {/*     <img src={require("../../assets/img/logo.png").default}></img> */}
              <div dangerouslySetInnerHTML={{ __html: props.Enamad }} />
            </div>


          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  routes: PropTypes.arrayOf(PropTypes.object),
};

export default Sidebar;
